module.exports = __webpack_public_path__ + "media/application/images/icons/white-arrow-right-ac2366d272d6fe494c1f4a9358a54a0b.svg";